import { ReactNode } from 'react'

export interface TabBarItem {
    header: ReactNode
    body: ReactNode
    disabled?: boolean
}

export enum TabSize {
    Large = 'Large',
    Medium = 'Medium',
}
